import Select from "components/shared/select";
import { HiddenDataWrapper } from "helpers/hiddenData";
import { getVisiblePages } from "helpers/pagination";
import React, { Component, lazy, Suspense } from "react";

const VIEWPORTTABLET = 769;
const SELECT_SIZES = {
    tablet: { containerHeight: "23px", inputHeight: "18px", lineHeight: "18px", fontSize: "14px" },
    mobile: { containerHeight: "18px", inputHeight: "13px", lineHeight: "12px", fontSize: "12px" },
};

const CsvDownload = lazy(() => import("./csvDownload.js"));

const defaultButton = (props) => <div {...props}>{props.children}</div>;

export default class Pagination extends Component {
    constructor(props) {
        super();
        this.state = {
            visiblePages: getVisiblePages(props.page + 1, props.pages),
            activePage: props.page + 1,
            selectSizes: this.responsiveHeights(),
        };
    }

    responsiveHeights() {
        return window.innerWidth >= VIEWPORTTABLET ? SELECT_SIZES.tablet : SELECT_SIZES.mobile;
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleWindowRezise);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowRezise);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.withoutRecalculatePages && prevProps.pages !== this.props.pages) {
            const activePage = this.props.page + 1;
            this.setState({
                visiblePages: getVisiblePages(activePage, this.props.pages),
                activePage,
            });
        } else if (prevProps.page !== this.props.page) {
            const activePage = this.props.page + 1;
            this.setState({ visiblePages: getVisiblePages(activePage, this.props.pages), activePage });
        }
    }

    handleWindowRezise = () => this.setState({ selectSizes: this.responsiveHeights() });

    changePage(page) {
        this.setState({
            visiblePages: getVisiblePages(page, this.props.pages),
            activePage: page,
        });

        this.props.onPageChange(page - 1);
    }

    renderPageSizeOptions = () => {
        const { pageSize, pageSizeOptions, onPageSizeChange, withoutPageSize } = this.props;
        if (withoutPageSize) {
            return;
        }
        const { containerHeight, inputHeight, lineHeight, fontSize } = this.state.selectSizes;
        const customStyles = {
            container: (styles) => ({ ...styles, width: "70px" }),
            control: (styles) => ({ ...styles, minHeight: containerHeight, fontSize, borderRadius: 0 }),
            singleValue: (styles) => ({ ...styles, height: inputHeight, lineHeight }),
            valueContainer: (styles) => ({ ...styles, lineHeight: inputHeight }),
            indicatorsContainer: (styles) => ({ ...styles, height: containerHeight }),
            dropdownIndicator: (styles) => ({ ...styles, padding: "4px" }),
            indicatorSeparator: () => ({ display: "none" }),
            option: (styles) => ({ ...styles, fontSize }),
        };
        const props = {
            inputProps: { name: "pageSize" },
            options: pageSizeOptions.map((option) => ({ label: `${option}`, value: option })),
            unSearchable: true,
            onChange: ({ value }) => onPageSizeChange(value),
            value: pageSize,
            unClearable: true,
            menuPlacement: "top",
            styles: { ...customStyles },
        };
        return (
            <div className="pagination__page-size-container">
                <Select {...props} />
                <HiddenDataWrapper>{this.renderDownloadLink()}</HiddenDataWrapper>
            </div>
        );
    };

    renderDownloadLink = () => {
        const { columns, data, isNotExportable } = this.props;
        if (isNotExportable) {
            return null;
        }

        return (
            <Suspense>
                <CsvDownload columns={columns} data={data} getListExcel={this.props.getListExcel} />
            </Suspense>
        );
    };

    render() {
        const { PageButtonComponent = defaultButton } = this.props;
        const { visiblePages, activePage } = this.state;
        const rangeStart = this.props.totalItems === 0 ? 0 : (activePage - 1) * this.props.pageSize + 1;
        const rangeEnd = Math.min(activePage * this.props.pageSize, this.props.totalItems);
        return (
            <div className="pagination--with-page-size">
                <div className="pagination__pages">
                    {this.props.pages > 6 && activePage > 4 && (
                        <PageButtonComponent className="pagination__item" onClick={() => this.changePage(1)}>
                            &laquo;
                        </PageButtonComponent>
                    )}
                    {visiblePages.map((page) => {
                        return (
                            <PageButtonComponent
                                key={page}
                                className={
                                    activePage === page
                                        ? "pagination__item pagination__item--active"
                                        : "pagination__item"
                                }
                                onClick={this.changePage.bind(this, page)}
                            >
                                {page}
                            </PageButtonComponent>
                        );
                    })}
                    {this.props.pages > 6 && activePage < this.props.pages - 2 && (
                        <PageButtonComponent
                            className="pagination__item"
                            onClick={() => this.changePage(this.props.pages)}
                        >
                            &raquo;
                        </PageButtonComponent>
                    )}
                    {this.props.showRange && (
                        <span className="pagination__item w-auto px-2 text-nowrap border-0 cursor-default">
                            {rangeStart}–{rangeEnd} из {this.props.totalItems}
                        </span>
                    )}
                </div>
                {this.renderPageSizeOptions()}
            </div>
        );
    }
}
